"use strict";

exports.__esModule = true;
var _AlertTicketTag = require("./AlertTicketTag");
Object.keys(_AlertTicketTag).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _AlertTicketTag[key]) return;
  exports[key] = _AlertTicketTag[key];
});